import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import {AsideAction, SidenavAction, SidenavSide, SidenavTemplate} from '../store/aside.action';

export class SidenavActionPayload {
    side: SidenavSide;
    type: SidenavAction;
    template: SidenavTemplate;

    constructor(side: SidenavSide, type: SidenavAction, template: SidenavTemplate = null) {
        this.side = side;
        this.type = type;
        this.template = template;
    }
}

@Injectable({
    providedIn: 'root'
})
export class SidenavService {

    actions: Subject<AsideAction.Generic> = new Subject<AsideAction.Generic>();

    constructor() {
    }

    dispatch(payload: AsideAction.Generic) {
        this.actions.next(payload);
    }
}
